import { render, staticRenderFns } from "./ForgotPasswordCsr.vue?vue&type=template&id=5603ebc1&scoped=true"
import script from "./ForgotPasswordCsr.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordCsr.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordCsr.vue?vue&type=style&index=0&id=5603ebc1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5603ebc1",
  null
  
)

export default component.exports